import privileges from '../modules/privileges.js'
import xhrModule from '../modules/xhrModule.js'

var helpers = {
	methods: {
		checkPrivilege: function (value, type) {
			var result = null
			if (type === 'canAccess') {
				result = privileges.canAccess(value)
			} else if (type === 'canCreate') {
				result = privileges.canCreate(value)
			} else if (type === 'canDelete') {
				result = privileges.canDelete(value)
			} else if (type === 'canUpdate') {
				result = privileges.canUpdate(value)
			}

			return result
		},

		renderColumnField: function (item, items, markets, column, linkedEntity) {
			var value = item.properties[column.name] || []
			var type = column.settings.type.value
			var entityName = linkedEntity.entity.name
			var references = linkedEntity.references
			var uuid = item.uuid

			// check if this element is a reference to something else
			var reference = false
			var entityProperties = linkedEntity.entity.properties
			for (var prop in entityProperties) {
				if (entityProperties[prop].name === column.name) {
					if (entityProperties[prop].settings.type === 'Reference') {
						reference = true

						var referencedContent = references[column.name]
						var convertedValues = []

						// Find name of property we want to show
						// Find the referenced field ID
						let referencedFieldId = null
						let refPropName = null
						for (var refProp in linkedEntity.entity.properties) {
							if (linkedEntity.entity.properties[refProp].name === column.name) {
								referencedFieldId = linkedEntity.entity.properties[refProp].settings.referenceFieldId
								const referencedEntityId = linkedEntity.entity.properties[refProp].settings.referenceId
								let tempProps = xhrModule.cachedEntities[referencedEntityId].properties
								for (var tmp in tempProps) {
									if (tempProps[tmp].id == referencedFieldId) {
										refPropName = tempProps[tmp].name
										break
									}
								}
								break
							}
						}

						// Find the entity for this reference
						for (var val = 0; val < value.length; val++) {
							// the reference can be either an object or an array
							var newVal = null

							if (Array.isArray(referencedContent[value[val]])) {
								if (referencedContent[value[val]][0]) {
									newVal = referencedContent[value[val]][0].properties[refPropName]
								}
							} else {
								var keys = Object.keys(referencedContent[value[val]])
								newVal = referencedContent[value[val]][keys[0]].properties[refPropName]
							}

							if (newVal) convertedValues.push(newVal)
						}
					}
				}
			}

			if (type === 'Dropzone' || type === 'Fileupload') {
				if (!value) return ''
				if (value.length < 1) return
				var output = ''
				var domain = Object.keys(this.$store.state.user.project.domains)[0].replace(/\/$/, '')
				var format = (str, arg) => arg.reduce((a, e) => a.replace(/%s/, e), str)

				for (var i = 0; i < value.length; i++) {
					output += format(
						'<div style="background-image: url(\'%s/uploads/optimized/%s/100x100/%s\')"></div>',
						[domain, entityName, value[i]]
					)
				}

				return '<div class="images">' + output + '</div>'
			} else if (type === 'Link') {
				if (!value) return ''
				if (!value[1]) return
				return value[1] + ' (' + value[0] + ')'
			} else if (type === 'Toggle') {
				return `<span class="status ${value == '1' ? 'active' : ''}"></span>`
			} else {
				if (!value) {
					var defaultLang = 1
					if (markets) {
						defaultLang = markets[Object.keys(markets)[1]].id
					}
					var originalItem = ''

					// Show the translation in the default language for this property
					for (var o = items.length - 1; o >= 0; o--) {
						if (items[o].uuid === uuid && items[o].market === defaultLang) {
							originalItem = items[o].properties[column.name]
							break
						}
					}

					var result = '<i class="not-translated">Empty or not translated' + '</i>'
					if (originalItem) result = result + ' (' + originalItem + ')'
					return result
				} else {
					if (reference) {
						return convertedValues.join(', ')
					} else {
						if (Array.isArray(value)) {
							return value.join(', ')
						} else {
							return value
						}
					}
				}
			}
		},

		getMultiSwitchClass: function (value) {
			switch (value) {
				case 1:
					return ''
				case 2:
					return 'active-step1'
				case 3:
					return 'active-step2'
				default:
					return ''
			}
		},

		checkIfValueExistsInArray: function (value, array) {
			if (!array) return false
			if (!Array.isArray(array)) array = JSON.parse(array)

			var index = -1
			for (var i = 0; i < array.length; i++) {
				if (array[i] == value) index = 0
			}

			if (index > -1) {
				return true
			} else {
				return false
			}
		},

		getInputValues: function (value) {
			// if our value is not a json array we have to make it one
			if (value[0] !== '[') {
				value = '["' + value + '"]'
			}
			var values = null
			var valuesArr = JSON.parse(value)
			if (!Array.isArray(valuesArr)) {
				values = JSON.parse(valuesArr)
			} else {
				values = valuesArr
			}

			return values
		},

		stripExtension: function (value) {
			var split = value.split('.')
			return split[0]
		},

		convertUserAgentString: function (ua) {
			let browser = ua
			switch (ua) {
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.93 Safari/537.36':
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.85 Safari/537.36':
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.212 Safari/537.36':
					browser = 'Chrome 90.0 Win10'
					break
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:88.0) Gecko/20100101 Firefox/88.0':
					browser = 'Firefox 88.0 Win10'
					break
				case 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:88.0) Gecko/20100101 Firefox/88.0':
					browser = 'Firefox 88.0 macOS'
					break
				case 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.93 Safari/537.36':
				case 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.85 Safari/537.36':
				case 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.212 Safari/537.36':
					browser = 'Chrome 90.0 macOS'
					break
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.128 Safari/537.36':
					browser = 'Chrome 89.0 Win10'
					break
				case 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0.3 Safari/605.1.15':
					browser = 'Safari 14.0 macOS'
					break
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.93 Safari/537.36 Edg/90.0.818.56':
				case 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.93 Safari/537.36 Edg/90.0.818.51':
					browser = 'Edge 90.0 Win10'
					break
			}

			return browser
		}
	}
}

export default helpers
